import { useEffect, useState } from "react";
import { API } from 'aws-amplify';
import { getAuthToken } from "../../../utils/AuthUtils";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import './styles.scss';

const CompanyDetailsModal = ({ show, onClose, id }) => {
    const [companyDetails, setCompanyDetails] = useState({});
    const [otherTickers, setOtherTickers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleClose = () => {
        setCompanyDetails({});
        setOtherTickers([]);
        setLoading(false);
        setError(false);
        setErrorMessage("");
        onClose();
    }

    const handleSetCompanyDetails = (companyData) => {
        const tickerList = [];
        for (const data of companyData) {
            if (!data.public || data.isPrimaryTicker) {
                setCompanyDetails(data);
            } else {
                const ticker = data.exchange + ":" + data.ticker;
                tickerList.push(ticker);
            }
        }
        setOtherTickers(tickerList);
    }

    useEffect(() => {
        if (id) {
            const retrieveCompanyDetails = async () => {
                setLoading(true);
                setError(false);
                setErrorMessage("");
                const authToken = await getAuthToken();
                const queryStringParameters = {
                    id: id
                }
                API.get("AnnualCompensations",
                    "/company-data/id", {
                    headers: {
                        'Content-Type': 'application/json',
                        Token: authToken,
                    },
                    queryStringParameters,
                }).then(response => {
                    handleSetCompanyDetails(response)
                    setLoading(false);
                }).catch(error => {
                    console.log(error);
                    setLoading(false);
                    setError(true);
                    setErrorMessage("Error retrieving company details");
                })
            };
            retrieveCompanyDetails();
        }

    }, [id]);

    return (
        <div>
            <Modal show={show} onHide={handleClose} size='lg' centered>
                <div className="company-details-container">
                    <Modal.Header closeButton>
                        Company Details
                    </Modal.Header>
                    <Modal.Body>
                        {loading ? <Spinner as="span" animation="grow" size="sm" aria-hidden="true" /> : <>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="companyName">
                                        <Form.Label>Company Name</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyName} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="capIqCode">
                                        <Form.Label>Cap IQ Code</Form.Label>
                                        <Form.Control type="text" value={companyDetails.capIqCode} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="companyId">
                                        <Form.Label>Company ID</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyId} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="tickerExchange">
                                        <Form.Label>Primary Ticker</Form.Label>
                                        <Form.Control type="text" value={companyDetails.ticker ? companyDetails.exchange + ":" + companyDetails.ticker : ""} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group controlId="otherTickers">
                                        <Form.Label>Other Tickers</Form.Label>
                                        <Form.Control type="text" value={otherTickers.join(", ")} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="sector">
                                        <Form.Label>Sector</Form.Label>
                                        <Form.Control type="text" value={companyDetails.sector} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group controlId="sector">
                                        <Form.Label>Industry</Form.Label>
                                        <Form.Control type="text" value={companyDetails.industry} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="city">
                                        <Form.Label>City</Form.Label>
                                        <Form.Control type="text" value={companyDetails.city} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="state">
                                        <Form.Label>State</Form.Label>
                                        <Form.Control type="text" value={companyDetails.state} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="country">
                                        <Form.Label>Country</Form.Label>
                                        <Form.Control type="text" value={companyDetails.country} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group controlId="description">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type="text" as="textarea" value={companyDetails.description} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="public">
                                        <Form.Label>Public</Form.Label>
                                        <Form.Check type="checkbox" checked={companyDetails.public} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                        }
                        {error && <Alert dismissible variant="danger" show={error} onClose={() => setError(false)}>{errorMessage}</Alert>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    )
}

export default CompanyDetailsModal;